module.exports = {"350802001":"东城街道","350802002":"南城街道","350802003":"西城街道","350802004":"中城街道","350802005":"西陂街道","350802006":"曹溪街道","350802007":"东肖街道","350802008":"龙门街道","350802009":"铁山街道","350802010":"北城街道","350802100":"红坊镇","350802101":"适中镇","350802102":"雁石镇","350802103":"白沙镇","350802104":"万安镇","350802105":"大池镇","350802106":"小池镇","350802107":"江山镇","350802108":"岩山镇","350802109":"苏坂镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350802.json
// module id = 1230
// module chunks = 0